const collect = require("collect.js");

function formatNumber(stringNumber) {
  return new Intl.NumberFormat("de-DE").format(stringNumber);
}

function sumCollection(collection, key) {
  let obj = collect(collection);
  return obj.sum(key);
}

module.exports = { formatNumber, sumCollection };
